import { render, staticRenderFns } from "./GoodsDetails.vue?vue&type=template&id=511fcd79&scoped=true"
import script from "./GoodsDetails.vue?vue&type=script&lang=js"
export * from "./GoodsDetails.vue?vue&type=script&lang=js"
import style0 from "./GoodsDetails.vue?vue&type=style&index=0&id=511fcd79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511fcd79",
  null
  
)

export default component.exports